<br/>Nb Équipes : {{playerCount}}
<br/>Réponses : {{submissionCount}}
<br/>En traitement : {{remainingItemsToReview}}
